module.exports = __webpack_public_path__ + "img/flex-o.3fc60741.svg";